import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import RightArrow from "../../components/SVG";
import SectionTitleSpecial from "../../components/SectionTitle/SectionTitleSpecial";
import shapeImg4 from "../../assets/img/event/shape-1-4.png";
import shapeImg5 from "../../assets/img/members_collage.webp";
import shapeImg6 from "../../assets/img/event/shape-1-6.png";
import eventImg from "../../assets/img/event/thumb-1.png";

import { Modal, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import ctaImg from "../../assets/img/about/cta-1.png";
const MembershipSection = () => {
  const [isOpen, setIsOpen] = useState(false);

  const downloadFrom = () => {
    setIsOpen(true);
  };

  const toggleModal = () => {
    setIsOpen(!isOpen);
  };
  return (
    <>
      <Modal
        show={isOpen}
        onHide={toggleModal}
        centered
        size="lg"
        dialogClassName="edge-to-edge-modal"
        backdropClassName="no-backdrop-padding"
      >
        <Modal.Body className="position-relative pb-40 pt-40 pr-20 pl-20">
          <Button
            variant="light"
            onClick={toggleModal}
            style={{
              position: "absolute",
              top: "30px",
              right: "20px",
              zIndex: 2,
              borderRadius: "50%",
              padding: "0.2rem 0.6rem",
              boxShadow: "0 0 10px rgba(0,0,0,0.2)",
              fontSize: "20px",
              fontWeight: "bold",
            }}
          >
            ✕
          </Button>

          <div className="it-student-area it-instructor-style">
            <div className="row">
              <div className="col-xl-12">
                <div className="">
                  <form>
                    <div className="it-student-regiform">
                      <h1
                        className="it-student-regiform-title"
                        style={{
                          fontSize: "30px",
                          fontWeight: "bold",
                          marginBottom: "0px",
                        }}
                      >
                        Download Application Form
                      </h1>
                      <hr />
                      <div className="it-student-regiform-wrap">
                        <div className="row">
                          <p>
                            Please Enter the details to download the Application
                            form
                          </p>
                          <div className="col-xl-6">
                            <div className="it-student-regiform-item">
                              <label>Full Name *</label>
                              <input type="text" />
                            </div>
                          </div>
                          <div className="col-xl-6">
                            <div className="it-student-regiform-item">
                              <label>City *</label>
                              <input type="text" />
                            </div>
                          </div>
                          <div className="col-xl-6">
                            <div className="it-student-regiform-item">
                              <label>Phone *</label>
                              <input type="text" />
                            </div>
                          </div>
                          <div className="col-xl-6">
                            <div className="it-student-regiform-item">
                              <label>Email Id *</label>
                              <input type="text" />
                            </div>
                          </div>
                          <div className="col-xl-6">
                            <button type="submit" className="ed-btn-theme">
                              Submit
                              <i>
                                <RightArrow />
                              </i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <div id="it-about" className="it-about-3-area fix pt-50 pb-50 p-relative">
        <div className="container">
          <div className="row align-items-center">
            <div
              className="col-xl-12 col-lg-12 wow animate__fadeInRight"
              data-wow-duration=".9s"
              data-wow-delay=".7s"
            >
              <div className="it-about-3-title-box">
                <SectionTitleSpecial
                  itemClass="it-about-title-box mb-20"
                  subTitle="Membership"
                  preTitle="SAP offers two kinds of"
                  highlightText=" memberships"
                  postTitle="Life Membership and Student Membership"
                />
              </div>
              <div className="it-about-3-mv-box">
                <div className="row">
                  <div className="col-xl-12 col-md-12">
                    <div className="it-about-3-mv-item">
                      <div className="col-xl-12 col-md-12">
                        <div className="it-about-4-list-wrap">
                          <div className="it-about-5-list">
                            <ul style={{ backgroundColor: "transparent" }}>
                              <li className="pr-0 pb-10 text-black">
                                <i className="fa-regular fa-angles-right"></i>A
                                Life Member shall be an aquaculture professional
                                who meets the following minimum eligibility
                                criteria : an undergraduate degree or
                                post-secondary diploma in an aquaculture-related
                                discipline or 2 years of work experience in
                                aquaculture. Aquaculture-related disciplines
                                shall be biology, fisheries science,
                                agriculture, veterinary science, food processing
                                technology, or engineering. Work experience can
                                be in any area of aquaculture : hatchery / farm
                                inputs, laboratory, post-harvest technology of
                                aquaculture products, research, extension,
                                teaching and administration.
                              </li>
                              <li className="pr-0 pb-10 text-black">
                                <i className="fa-regular fa-angles-right"></i>
                                Student Member shall be an individual who at the
                                time of enrollment in the Society is a duly
                                registered student in a recognized institution
                                of higher education for a diploma or degree
                                programme in aquaculture or a related
                                discipline. He or she shall remain as a Student
                                Member until he or she completes his educational
                                programme within the reasonable time required to
                                complete the programme.
                              </li>
                            </ul>
                          </div>
                        </div>
                        <p>
                          You can apply and pay for
                          <a
                            href="signup"
                            style={{ color: "#704fe6", fontWeight: "bold" }}
                          >
                            {" "}
                            Life Membership online{" "}
                          </a>
                          or by downloading the{" "}
                          <a
                            href="#"
                            onClick={downloadFrom}
                            style={{ color: "#704fe6", fontWeight: "bold" }}
                          >
                            application form
                          </a>{" "}
                          and following the procedures for its submission.
                          Student Membership needs to be applied offline only
                          and by downloading the{" "}
                          <a
                            href="#"
                            onClick={downloadFrom}
                            style={{ color: "#704fe6", fontWeight: "bold" }}
                          >
                            application form
                          </a>{" "}
                          and following the procedures for its submission.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="it-event" className="it-event-area p-relative pt-0 pb-50 fix">
        <div className="it-event-shape-6">
          <img src={shapeImg4} alt="" />
        </div>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-7 col-lg-7">
              <div className="it-event-left">
                <SectionTitleSpecial
                  itemClass="it-about-title-box mb-20"
                  subTitle="Membership Benefits"
                  preTitle="Explore the Perks of Our "
                  highlightText=" Membership"
                />

                <div className="it-event-content">
                  <div className="it-about-3-mv-item section-title-fixed-width">
                    <span className="it-about-3-mv-title">Life Members</span>
                    <div className="col-xl-12 col-md-12">
                      <div className="it-about-4-list-wrap">
                        <div className="it-about-5-list">
                          <ul style={{ backgroundColor: "transparent" }}>
                            <li className="pr-0 pb-10 text-black">
                              <i className="fa-regular fa-angles-right"></i>
                              Access to SAP’s events at no or low cost
                            </li>
                            <li className="pr-0 pb-10 text-black">
                              <i className="fa-regular fa-angles-right"></i>
                              Opportunities for professional development through
                              participation in SAP’s activities
                            </li>
                            <li className="pr-0 pb-10 text-black">
                              <i className="fa-regular fa-angles-right"></i>
                              Networking with top and emerging leaders in the
                              aquaculture industry, academia and research world
                            </li>
                            <li className="pr-0 pb-10 text-black">
                              <i className="fa-regular fa-angles-right"></i>
                              Reach the strategic partners of SAP such as the
                              Global Aquaculture Alliance, World Aquaculture
                              Society and the Institution of Aquaculture and
                              gain from their exclusive offers for SAP members
                            </li>
                          </ul>
                        </div>
                      </div>
                      <Link className="ed-btn-theme mb-40" to="/signup">
                        SignUp for Life Membership
                        <i>
                          <RightArrow />
                        </i>
                      </Link>
                    </div>
                    <span className="it-about-3-mv-title">Student Members</span>
                    <div className="col-xl-12 col-md-12">
                      <div className="it-about-4-list-wrap">
                        <div className="it-about-5-list">
                          <ul style={{ backgroundColor: "transparent" }}>
                            <li className="pr-0 pb-10 text-black">
                              <i className="fa-regular fa-angles-right"></i>A
                              defined number of seats reserved in SAP events
                            </li>
                            <li className="pr-0 pb-10 text-black">
                              <i className="fa-regular fa-angles-right"></i>Same
                              opportunities for professional development and
                              networking. Additionally, mentorship and career
                              opportunities
                            </li>
                          </ul>
                        </div>
                      </div>
                      <Link
                        className="ed-btn-theme mb-40"
                        to="/student-register"
                      >
                        SignUp for Student Membership
                        <i>
                          <RightArrow />
                        </i>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-5 col-lg-5">
              <img src={shapeImg5} alt="" />
            </div>
          </div>
        </div>
      </div>
      <div className="it-cta-area it-cta-height black-bg p-relative ">
        <div className="it-cta-bg d-none d-xl-block">
          <img src={ctaImg} alt="" />
        </div>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xxl-9 col-xl-8 col-lg-7 col-md-7">
              <div className="it-cta-content">
                <h4 className="it-cta-title">If you are not a SAP Member,</h4>
                <p className=" it-cta-text text-white">
                  If you are unable to sign in, please email
                  contact@aquaprofessional.org for assistance
                </p>
              </div>
            </div>
            <div className="col-xxl-3 col-xl-4 col-lg-5 col-md-5">
              <div className="it-cta-button text-md-end">
                <Link
                  className="ed-btn-theme"
                  to="/membership-application"
                  style={{ backgroundColor: "#704fe6" }}
                >
                  Join Now
                  <i style={{ backgroundColor: "#785dd7" }}>
                    <RightArrow />
                  </i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default MembershipSection;
